module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "2em 3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.know_terms) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.card_view.card1) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('h3', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Enter your details to create an account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.formComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "firstname",
      "title": "Enter  name",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 input-container"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg input-field",
    attrs: {
      "id": "email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "change": function($event) {
        _vm.validateEmail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_checking.email) ? _c('i', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.email && _vm.action_verified.email) && (!_vm.error_messages.email)) ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.email) ? _c('i', {
    staticClass: "icon fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.error_messages.email) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.email))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 input-container"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-group-lg input-field",
    attrs: {
      "id": "phone",
      "type": "number",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": "Your Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "change": function($event) {
        _vm.validatePhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_checking.phone) ? _c('i', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.phone && _vm.action_verified.phone) && (!_vm.error_messages.phone)) ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.phone) ? _c('i', {
    staticClass: "icon fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.error_messages.phone) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.phone))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 input-container"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Ref Code")]), _vm._m(0), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ref_code),
      expression: "ref_code"
    }],
    staticClass: "form-control input-group-lg input-field",
    attrs: {
      "type": "text",
      "size": "4",
      "title": "Enter Ref Code",
      "placeholder": "Ref Code"
    },
    domProps: {
      "value": (_vm.ref_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ref_code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v("I agree to "), _c('a', {
    staticStyle: {
      "cursor": "pointe"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(true)
      }
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), (!_vm.terms) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.terms))]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg_step_01
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (_vm.card_view.card2) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "left",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setCardGuide('card1')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("secure your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.form2ComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 input-container"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control input-group-lg input-field",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "username",
      "title": "Enter  name",
      "placeholder": "Your User Name"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "change": function($event) {
        _vm.validateUsername()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_checking.username) ? _c('i', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.username && _vm.action_verified.username) && (!_vm.error_messages.username)) ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.username) ? _c('i', {
    staticClass: "icon fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.error_messages.username) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password",
      "type": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg_step_02
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (!_vm.card_view.card3) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.card_view.card3) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("@" + _vm._s(_vm.user.username))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "float": "right",
      "font-size": "24px",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(false)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('h3', [_vm._v("Terms and condition")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("REF CODE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v("Get Your "), _c('br'), _vm._v(" MARKET ID")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Already have an account? - Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("MARKET ID: ")]), _vm._v("8977uu889999")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-onboarding"
  }, [_c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "buypoint"
    }
  }, [_vm._v("Pick your Buying Interests")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "create?t=new"
    }
  }, [_vm._v("Register Businesses and create Sellpoints")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "account"
    }
  }, [_vm._v("Set Up account")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84b107fc"}!./src/pages/Register/template.html
// module id = 421
// module chunks = 0